module.exports = __webpack_public_path__ + "static/media/2000L.fe1be52.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/pure_tone/2000L.mp3
// module id = DUBT
// module chunks = 1